define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore"
], function(array, declare, lang, csi, _) {

	var JSNode;

	// the singleton emulating some functionality of XML Document
	var Document = {
		createElement: function(tagName) {
			return new JSNode({}, tagName);
		}
	};

	function _addToArray(newObj, o) {
		if (o != null) {
			if (o.length == null) {
				if (newObj)
					newObj.push(o);
				else
					newObj = [o];
			} else {
				if (newObj)
					newObj = newObj.concat(o);
				else
					newObj = o;
			}
		}
		return newObj;
	}

	function _addWrappedToArray(newObj, obj, k) {
		var o = JSNode.wrapObject(obj, false, k);
		return _addToArray(newObj, o);
	}

	function convertToXML(/*Object*/obj,/*DOM Document*/xmlDoc,/*XML Element*/parentElement,/*int*/indentLevel) {
		function indent(elem, indentNum) {
			if (indentLevel != null && elem != null && indentNum > 0) {
				var s = "\n";
				for (var i = 0; i < indentNum; ++i)
					s += "    ";
				elem.appendChild(xmlDoc.createTextNode(s));
			}
		}

		function addNewElem(newElem) {
			if (parentElement)
				parentElement.appendChild(newElem);
			results.push(newElem);
		}

		var results = [];
		var indentedChildrenExist = false;
		// if the object is built-in object (like String, Number and etc.)
		// convert it into the text node
		if (obj == null || typeof (obj) != "object") {
			addNewElem(xmlDoc.createTextNode(obj));
		} else if (obj.previousSibling !== undefined) {
			// may be it's already an XML node?
			// Then import it into our XML document
			addNewElem(xmlDoc.importNode(obj, true));
		} else {
			for (var k in obj) {
				var prop = obj[k];

				// if the property is Object, convert it to XML Element
				if (prop != null && typeof (prop) == "object") {
					// in case it's an Array, create a list of XML Elements with the same tag name
					if (!_.isArray(prop))
						prop = [prop];
					for (var i = 0; i < prop.length; ++i) {
						indentedChildrenExist = true;

						indent(parentElement, indentLevel);

						// may be it's already an XML node?
						// Then import it into our XML document
						if (prop[i].previousSibling !== undefined) {
							addNewElem(xmlDoc.importNode(prop[i], true));
						} else {
							var newElem = xmlDoc.createElement(k);
							addNewElem(newElem);

							// assign the content to the newly created element
							convertToXML(prop[i], xmlDoc, newElem, (indentLevel == null) ? null : (indentLevel + 1));
						}
					}
				} else {
					if (k == '$') {
						// this property is a special case of the XML element having attributes,
						// but not having any children elements except text. The content of this property is this text.
						// Convert it into a text node.
						addNewElem(xmlDoc.createTextNode(prop));
					} else {
						// the property is either Boolean, Number or String here. Convert it to an attribute
						parentElement.setAttribute(k, String(prop));
					}
				}
			}
		}

		if (indentedChildrenExist && indentLevel != null)
			indent(parentElement, indentLevel - 1);
		return results;
	}

	// emulate some functionality of XML Node
	JSNode = declare(null, {
		jsNode: null,	// Javascript object used as a content of the node
		tagName: null,	// emulation of DOM Core Element

		ownerDocument: Document,

		constructor: function(obj, tagName) {
			this.jsNode = obj;
			this.tagName = tagName;
		},

		selectSingleNode: function(path) {
			var results = this._selectNodes(path, true);
			return (results && results.length > 0) ? results[0] : null;
		},

		selectNodes: function(path) {
			var results = this._selectNodes(path);
			return (results && results.length > 0) ? results : null;
		},

		getAttribute: function(attrName) {
			return this.jsNode[attrName];
		},

		setAttribute: function(attrName, val) {
			this.jsNode[attrName] = val;
		},

		cloneNode: function(deep) {
			if (!deep)
				throw new Error("JSNode supports the deep clone only");

			return csi.deepCopy(this);
		},

		appendChild: function(/*JSNode|XMLNode*/node) {
			var oldObj = this.jsNode[node.tagName];
			var newNode = node.jsNode || node;

			if (oldObj == null)
				this.jsNode[node.tagName] = newNode;
			else if (_.isArray(oldObj))
				oldObj.push(newNode);
			else
				this.jsNode[node.tagName] = [oldObj, newNode];
		},

		getElementText: function() {
			if (_.isString(this.jsNode))
				return this.jsNode;

			return this.jsNode["$"];
		},

		asXML: function(/*DOM Document*/xmlDoc,/*bool*/prettyPrint) {
			// summary: creates XML representation of this node
			if (this.tagName != null) {
				var newElem = xmlDoc.createElement(this.tagName);

				var results = convertToXML(this.jsNode, xmlDoc, newElem, prettyPrint ? 1 : null);

				if (prettyPrint) {
					// did we add some 'Element' nodes? If yes, then add a new line.
					var indentedChildrenExist = array.some(results, function(node) {
						return node.nodeType == 1;	// looking for 'Element' node
					});
					if (indentedChildrenExist)
						newElem.appendChild(xmlDoc.createTextNode("\n"));
				}

				return newElem;
			} else {
				var results = convertToXML(this.jsNode, xmlDoc, null, prettyPrint ? 1 : null);

				return (results.length > 1) ? results : results[0];
			}
		},

		_selectNodes: function(path, breakAfterFirst) {

			var breakNow = false;
			var stepUsed;	// the step in the XPath used to get the object

			function goDownOfPath(obj, downPath) {
				if (_.isString(obj))
					return null;

				downPath = downPath.split("/");
				for (var i = (downPath.length > 0 && downPath[0].length == 0) ? 1 : 0; obj != null && i < downPath.length; i++) {
					var curPath = downPath[i];

					// we support "|" operation in the path, but only as a last element
					var orIndex = curPath.indexOf("|");
					if (orIndex >= 0) {
						var alternatives = curPath.split("|");
						var newObj = null;
						for (var ai = 0; ai < alternatives.length; ++ai) {
							var k = alternatives[ai];
							newObj = _addWrappedToArray(newObj, obj[k], k);
							if (breakAfterFirst && newObj.length > 0)
								break;
						}
						obj = newObj;
						breakNow = true;
						if (i < downPath.length - 1) {
							console.warn("JSNode._selectNodes: path is not processed completely. Path=", path);
						}
						break;
					}

					if ("child::*" != curPath) {
						stepUsed = curPath;

						// the more correct (but more slower) version supporting the array of nodes
						// in the middle of the path is commented out below
						obj = obj[curPath];
						/*
						if (!_.isArray(obj)) {
							obj = obj[curPath];
						} else {
							// iterate over the array and look for 'curPath' in each element
							var newObj = [];
							for (var ai=0; ai < obj.length; ++ai) {
								var o = obj[ai];
								if (o != null) {
									o = o[curPath];
									if (o != null) {
										if (_.isArray(o))
											newObj = newObj.concat(o);
										else
											newObj.push(o);
	
										if (breakAfterFirst && newObj.length > 0)
											break;
									}
								}
							}
							obj = newObj;
						}
						*/
					} else {
						// Wrap each element into JSNode.
						// The key for this element is the key from the source object.
						//
						// if the element is an Array, wrap each element of the Array into JSNode
						// Each element in this array will have the same key.
						var newObj = null;
						for (var k in obj) {
							var o = obj[k];
							o = filterByPredicateAndWrap(o, k);
							newObj = _addToArray(newObj, o);
							if (breakAfterFirst && newObj.length > 0)
								break;
						}
						obj = newObj;
						breakNow = true;
						if (i < downPath.length - 1) {
							console.warn("JSNode._selectNodes: path is not processed completely. Path=", path);
						}
						break;
					}
				}
				return obj;
			}

			function attributeAxis(path, startPredicateIndex) {
				if (startPredicateIndex < 0)
					return null;

				// we support one predicate only with only one attribute matching
				var endIndex = path.indexOf("]", startPredicateIndex + 1);
				if (endIndex < 0)
					return [];

				path = path.substring(startPredicateIndex + 1, endIndex);

				// find the name of attribute
				var attrName = null;
				var m = /@\w+/.exec(path);
				if (m)
					attrName = m[0].substring(1);
				else
					return [];

				// find the attribute value
				var attrValue = null;
				m = /".+"/.exec(path);
				if (m)
					attrValue = m[0].slice(1, -1);

				return [{name: attrName, value: attrValue}];
			}

			function attributeConditionMatched(obj, attrCondition) {
				if (attrCondition == null)
					return true;

				for (var i = 0; obj && i < attrCondition.length; i++) {
					var ac = attrCondition[i];

					var attrValue = obj[ac.name];
					if (attrValue != ac.value)
						return false;
				}
				return true;
			}

			function filterByPredicateAndWrap(obj, stepUsed) {
				if (!_.isArray(obj))
					obj = [obj];

				if (startPredicateIndex < 0) {
					// no predicates, just convert to JSNodes
					return JSNode.wrapObject(obj, breakAfterFirst, stepUsed);
				} else {
					// check predicate
					var results = [];
					for (var i = 0; i < obj.length; i++) {
						var o = obj[i];
						if (attributeConditionMatched(o, attrCondition)) {
							results.push(JSNode.wrapObject(o, false, stepUsed));
							if (breakAfterFirst)
								break;
						}
					}

					return results;
				}
			}

			// start of the function
			var obj = this.jsNode;

			// we support one predicate only with only one attribute matching
			var startPredicateIndex = path.indexOf("[");

			// the condition will be used in 'filterByPredicateAndWrap' function
			var attrCondition = attributeAxis(path, startPredicateIndex);

			// go down to the element path
			obj = goDownOfPath(obj, (startPredicateIndex >= 0) ? path.substring(0, startPredicateIndex) : path);
			if (obj == null || breakNow) {
				return obj;
			}

			return filterByPredicateAndWrap(obj, stepUsed);
		}
	});

	lang.mixin(JSNode, {
		wrapObject: function(obj, breakAfterFirst, tagName) {
			if (!obj)
				return null;
			else if (!_.isArray(obj))
				return new JSNode(obj, tagName);
			else {
				// it is an array
				var nodes = [];
				for (var i = 0; i < obj.length; i++) {
					var o = obj[i];
					if (o != null) {
						// in case of adding Debug module to SiteMerged file, there can be a mix of JSNodes and XMLNodes;
						// in this case, just pass XML object through. Hopefully it won't cause any problems.
						nodes.push(o.tagName ? o : new JSNode(o, tagName));
						if (breakAfterFirst)
							break;
					}
				}
				return nodes;
			}
		}
	});

	return JSNode;
});